import type { FlexLayoutProps } from '..'

export default (config: {
  props: Pick<
    FlexLayoutProps,
    'alignContent' | 'alignItems' | 'direction' | 'flexWrap' | 'justifyContent'
  >
}) => {
  const { props } = config
  return {
    default: {
      wrap: {
        alignContent: props.alignContent,
        alignItems: props.alignItems,
        display: 'flex',
        flexDirection: props.direction,
        flexWrap: props.flexWrap,
        justifyContent: props.justifyContent,
        height: '100%',
        width: '100%',
      },
    },
  } as const
}
